<script setup>
import { ref, onMounted } from "vue";
import WidgetLayout from "@/Layouts/WidgetLayout.vue";

const props = defineProps({
  office: Object,
  widgetkey: String,
  widgeteid: String,
});
const backUrl = ref("/");

let pymChild = null;

onMounted(() => {
  if (typeof pym !== "undefined") {
    pymChild = new pym.Child({ id: props.widgeteid });
  }
});
function backClicked() {
  let url = route("widget.iframe.step1", {
    key: props.widgetkey,
    eid: props.widgeteid,
  });
  backUrl.value = url;
}
</script>

<template>
  <WidgetLayout :office="props.office">
    <h2 class="lg:w-2/3 text-3xl mb-8">
      <p class="font-semibold mb-2">Vielen Dank für Ihre Terminanfrage!</p>
      Sie erhalten eine Bestätigung per E-Mail sobald Ihr Termin freigegeben
      wurde.
    </h2>

    <div class="py-6 mb-8">
      Herzliche Grüße
      <h2 class="text-3xl">Ihre {{ props.office.name }}</h2>
    </div>

    <div class="py-6 flex justify-between mb-60">
      <a
        class="px-6 md:px-20 py-3 text-xl font-semibold rounded-lg text-white bg-primary hover:opacity-70 cursor-pointer"
        @click="backClicked"
        :href="backUrl"
        >Zurück zum Anfang</a
      >
    </div>
  </WidgetLayout>
</template>

<style>
.bg-primary {
  background-color: #006eb4;
}
</style>
